/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiOffIcon16Light = forwardRef('NetConnectWifiOffIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.854 1.146a.5.5 0 1 0-.708.708L3.503 4.21a9 9 0 0 0-2.23 1.817.5.5 0 0 0 .747.665 8 8 0 0 1 2.219-1.747L6.523 7.23A5.001 5.001 0 0 0 4.09 8.888a.5.5 0 0 0 .782.624 4 4 0 0 1 2.48-1.452l5.793 5.794a.5.5 0 0 0 .708-.708l-12-12Z" }),
        React.createElement("path", { d: "m9.218 7.158 2.506 2.505a.5.5 0 0 0 .19-.768 5 5 0 0 0-2.696-1.737Z" }),
        React.createElement("path", { d: "m5.44 3.379.82.82a8 8 0 0 1 7.721 2.495.5.5 0 0 0 .748-.664 9 9 0 0 0-9.29-2.651Z" }),
        React.createElement("path", { d: "M8.707 12.714A1 1 0 1 0 7.293 11.3a1 1 0 0 0 1.414 1.414Z" })));
});
